import { Routes, Route, useLocation } from 'react-router-dom';
import Header from './Header';
import Home from './Home';
import Menu from './Menu';
import Footer from './Footer';
import Register from './Register';
import ChangePassword from './ChangePassword';
import Login from './Login';
//Other
import SpeechPre from './Other/SpeechPre';
import MasterMenu from './Other/MasterMenu';
import ComposeMessage from './Other/ComposeMessage';
import News from './Other/News';
import AddDept from './Other/AddDept';
import AddDesignation from './Other/AddDesignation';
import GenerateBarcode from './Other/GenerateBarcode';
import Support from './Other/Support';
import AddTemplate from './Other/AddTemplate';
import EditTemplate from './Other/EditTemplate';
import MisMenu from './Other/MisMenu';
import MisCollection from './Other/MisCollection';
//Accounting
import AccountMenu from './Accounting/AccountMenu';
import AddBank from './Accounting/AddBank';
import AddDeposit from './Accounting/AddDeposit';
import AddCheque from './Accounting/AddCheque';
import AccountReport from './Accounting/AccountReport';
//Hrms
import HrmsMenu from './Hrms/HrmsMenu';
import AddEmployee from './Hrms/AddEmployee';
import EmpList from './Hrms/EmpList';
import EditEmployee from './Hrms/EditEmployee';
import ViewEmployee from './Hrms/ViewEmployee';
import GeneratePayslip from './Hrms/GeneratePayslip';
import SalaryList from './Hrms/SalaryList';
import ViewPayslip from './Hrms/ViewPayslip';
import Shift from './Hrms/Shift';
import EditShift from './Hrms/EditShift';
import EmpRooster from './Hrms/EmpRooster';
import LeaveApplication from './Hrms/LeaveApplication';
//Ticketing
import Ticketing from './Ticketing/Ticketing';
import TicketMenu from './Ticketing/TicketMenu';
import TicketResponse from './Ticketing/TicketResponse';

//CRM
import CrmMenu from './Crm/CrmMenu';
import LeadList from './Crm/LeadList';

//Stores
import StoresMenu from './Stores/StoresMenu';
import EqpPoList from './Stores/EqpPoList';
import EqpPoInvoice from './Stores/EqpPoInvoice';
import EqpNewProduct from './Stores/EqpNewProduct';
import AddSupplier from './Stores/AddSupplier';
import EditSupplier from './Stores/EditSupplier';
import AddEqpCat from './Stores/AddEqpCat';
import EditEqpCat from './Stores/EditEqpCat';
import AddEqpSubCat from './Stores/AddEqpSubCat';
import EditEqpSubCat from './Stores/EditEqpSubCat';
import EqpRaiseIndent from './Stores/EqpRaiseIndent';
import EqpGrnEntry from './Stores/EqpGrnEntry';
import EqpGrnList from './Stores/EqpGrnList';
import EqpGrnInvoice from './Stores/EqpGrnInvoice';
import EqpPurchaseReturn from './Stores/EqpPurchaseReturn';
import EqpInvoiceReturn from './Stores/EqpInvoiceReturn';
import SupplierSearch from './Stores/SupplierSearch';
import SupplierPayment from './Stores/SupplierPayment';
import EquipList from './Stores/EquipList';
import EditEqp from './Stores/EditEqp';
import IndentEqpList from './Stores/IndentEqpList';
import EditIndentEqp from './Stores/EditIndentEqp';
import EqpInvoiceIndent from './Stores/EqpInvoiceIndent';
import IssueIndentEqp from './Stores/IssueIndentEqp';
import EqpReturnReport from './Stores/EqpReturnReport';
import EqpGstReport from './Stores/EqpGstReport';
import EqpGstStat from './Stores/EqpGstStat';

import ManufacturingMenu from './Manufacturing/ManufacturingMenu';
import ManufacturingDashboard from './Manufacturing/ManufacturingDashboard';

import AddExpense from './Other/AddExpense';
import ExpenseReport from './Other/ExpenseReport';
import Events from './Other/Events';
import ToDo from './Other/ToDo';
import EditToDo from './Other/EditToDo';
// Product
import ProductPage from "./Manufacturing/ProductPage";
import EditProduct from "./Manufacturing/EditProduct";

// BOM
import BOMPage from "./Manufacturing/BOMPage";
import EditBOM from "./Manufacturing/EditBOM";

// BOMItem
import BOMItemPage from "./Manufacturing/BOMItemPage";
import EditBOMItem from "./Manufacturing/EditBOMItem";

// WorkCenter
import WorkCenterPage from "./Manufacturing/WorkCenterPage";
import EditWorkCenter from "./Manufacturing/EditWorkCenter";

// Machine
import MachinePage from "./Manufacturing/MachinePage";
import EditMachine from "./Manufacturing/EditMachine";

// Production Order
import ProductionOrderPage from "./Manufacturing/ProductionOrderPage";
import EditProductionOrder from "./Manufacturing/EditProductionOrder";

// Material Issue
import MaterialIssuePage from "./Manufacturing/MaterialIssuePage";
import EditMaterialIssue from "./Manufacturing/EditMaterialIssue";

// Production Entry
import ProductionEntryPage from "./Manufacturing/ProductionEntryPage";
import EditProductionEntry from "./Manufacturing/EditProductionEntry";

// Maintenance
import MaintenancePage from "./Maintenance/MaintenancePage";
import EditMaintenance from "./Maintenance/EditMaintenance";

import PreventiveMaintenancePage from "./Maintenance/PreventiveMaintenancePage";
import EditPreventiveMaintenance from "./Maintenance/EditPreventiveMaintenance";

import BreakdownPage from "./Maintenance/BreakdownPage";
import EditBreakdown from "./Maintenance/EditBreakdown";

import SparePartsPage from "./Maintenance/SparePartsPage";
import EditSparePart from "./Maintenance/EditSparePart";

import RFIDTagPage from "./Manufacturing/RFIDTagPage";
import BranchPage from "./Manufacturing/BranchPage";
import ProductMovement from "./Manufacturing/ProductMovement";
import IOTDevicePage from "./Manufacturing/IOTDevicePage";
import IOTDataPage from "./Manufacturing/IOTDataPage";
import IOTMapPage from "./Manufacturing/IOTMapPage";
import ControlRoomDashboard from "./Manufacturing/ControlRoomDashboard";


import FloatingChatbot from './Other/FloatingChatbot';
import {AuthProvider} from '../context/AuthContext';
import PrivateRoute from './PrivateRoute';
import { useState } from 'react';


function Main() {
  const location = useLocation();

  // Hide chatbot on login page
  const showChatbot = location.pathname !== "/user-login";
  return (
    <div className="App">
             <AuthProvider>
               <Header />
               <Routes>
                    <Route element={<PrivateRoute allowedRoles={['Admin']}/>}>
                        <Route path="/user-register" element={<Register />}  />
                        <Route path="/master-menu" element={<MasterMenu />} />
                        <Route path="/mis-menu" element={<MisMenu />} />
                         
                    </Route>

                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Accounting']}/>}>
                        <Route path="/account-menu" element={<AccountMenu />} />
                        //Accounting
                        <Route path="/add-bank" element={<AddBank />} />
                        <Route path="/add-deposit" element={<AddDeposit />} />
                        <Route path="/add-cheque" element={<AddCheque />} />
                        <Route path="/account-report" element={<AccountReport />} />
                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Hr']}/>}>
                       <Route path="/hrms-menu" element={<HrmsMenu />} />
                       //Hrms
                        <Route path="/add-employee" element={<AddEmployee />} />
                        <Route path="/emp-list" element={<EmpList />} />
                        <Route path="/edit-emp/:id" element={<EditEmployee />} />
                        <Route path="/emp-view/:id/" element={<ViewEmployee />} />
                        <Route path="/generate-payslip/:id/" element={<GeneratePayslip />} />
                        <Route path="/salary-list" element={<SalaryList />} />
                        <Route path="/view-payslip/:emp_id/:id/" element={<ViewPayslip />} />
                        <Route path="/add-shift" element={<Shift />} />
                        <Route path="/shift-view/:id/" element={<EditShift />} />
                        <Route path="/emp-rooster" element={<EmpRooster />} />
                        <Route path="/emp-leave" element={<LeaveApplication />} />
                    </Route>

                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Stores']}/>}>
                        <Route path="/stores-menu" element={<StoresMenu />} />
                        //Stores Masters
                        <Route path="/add-supplier" element={<AddSupplier />} />
                        <Route path="/edit-supplier/:id" element={<EditSupplier />} />
                        <Route path="/add-eqp-cat" element={<AddEqpCat />} />
                        <Route path="/edit-eqp-cat/:cat_id" element={<EditEqpCat />} />
                        <Route path="/add-eqp-subcat" element={<AddEqpSubCat />} />
                        <Route path="/edit-eqp-subcat/:subcat_id" element={<EditEqpSubCat />} />
                        <Route path="/equip-list" element={<EquipList />} />
                        <Route path="/indent-eqp-list" element={<IndentEqpList />} />

                        //Stores
                        <Route path="/eqp-po-list" element={<EqpPoList />} />
                        <Route path="/eqp-po-invoice/:grn_id/" element={<EqpPoInvoice />} />
                        <Route path="/add-eqp-product" element={<EqpNewProduct />} />
                        <Route path="/eqp-raise-indent" element={<EqpRaiseIndent />} />
                        <Route path="/eqp-invoice-indent/:sale_pharm/" element={<EqpInvoiceIndent />} />
                        <Route path="/eqp-grn-entry" element={<EqpGrnEntry />} />
                        <Route path="/eqp-grn-list" element={<EqpGrnList />} />
                        <Route path="/eqp-grn-invoice/:grn_id/" element={<EqpGrnInvoice />} />
                        <Route path="/eqp-purchase-return" element={<EqpPurchaseReturn />} />
                        <Route path="/eqp-invoice-return/:pur_return" element={<EqpInvoiceReturn />} />
                        <Route path="/supplier-search" element={<SupplierSearch />} />
                        <Route path="/supplier-payment/:supp_id/" element={<SupplierPayment />} />
                        <Route path="/edit-eqp/:id/" element={<EditEqp />} />
                        <Route path="/edit-indent-eqp/:id/" element={<EditIndentEqp />} />
                        <Route path="/issue-indent-eqp/:id/" element={<IssueIndentEqp />} />
                        <Route path="/eqp-return-report" element={<EqpReturnReport />} />
                        <Route path="/eqp-gst-report" element={<EqpGstReport />} />
                        <Route path="/eqp-gst-stat" element={<EqpGstStat />} />
                    </Route>

                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Management']}/>}>
                        <Route path="/mis-collection" element={<MisCollection />} />
                        <Route path="/add-department" element={<AddDept />} />
                        <Route path="/add-designation" element={<AddDesignation />} />
                        <Route path="/barcode" element={<GenerateBarcode />} />

                        <Route path="/add-template" element={<AddTemplate />} />
                        <Route path="/edit-template/:id" element={<EditTemplate />} />

                        <Route path="/add-expense" element={<AddExpense />} />
                        <Route path="/expense-report" element={<ExpenseReport />} />

                    </Route>
                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Crm']}/>}>
				        //Crm
                        <Route path="/crm-menu" element={<CrmMenu />} />
                        <Route path="/lead-list" element={<LeadList />} />
                    </Route>

                    <Route element={<PrivateRoute allowedRoles={['Admin', 'Hr', 'Accounting', 'Stores', 'Management', 'Crm']}/>}>
                        <Route path="/" element={<Home />}  exact />
                        <Route path="/support" element={<Support />} />
                        <Route path="/change-password" element={<ChangePassword />}  />
                        <Route path="/admin-menu" element={<Menu />} />
                        <Route path="/news" element={<News />} />
                        <Route path="/comp-mess" element={<ComposeMessage />} />
                        //Ticketing
                        <Route path="/ticket-menu" element={<TicketMenu />} />
                        <Route path="/ticketing" element={<Ticketing />} />
                        <Route path="/ticket-response" element={<TicketResponse />} />
                        <Route path="/events" element={<Events />} />
                        <Route path="/todolist" element={<ToDo />} />
                        <Route path="/edit-todolist/:id" element={<EditToDo />} />

                        <Route path="/products" element={<ProductPage />} />
                        <Route path="/products/edit/:id" element={<EditProduct />} />

                        <Route path="/manufacturing-menu" element={<ManufacturingMenu />} />
                        <Route path="/manu-dash" element={<ManufacturingDashboard />} />

                        {/* BOM */}
                        <Route path="/bom" element={<BOMPage />} />
                        <Route path="/bom/edit/:id" element={<EditBOM />} />
                        {/* BOM Item */}
                        <Route path="/bomitem" element={<BOMItemPage />} />
                        <Route path="/bomitem/edit/:id" element={<EditBOMItem />} />

                        {/* Work Center */}
                        <Route path="/work-centers" element={<WorkCenterPage />} />
                        <Route path="/work-centers/edit/:id" element={<EditWorkCenter />} />

                        {/* Machine */}
                        <Route path="/machines" element={<MachinePage />} />
                        <Route path="/machines/edit/:id" element={<EditMachine />} />

                        {/* Production Order */}
                        <Route path="/production-orders" element={<ProductionOrderPage />} />
                        <Route path="/production-orders/edit/:id" element={<EditProductionOrder />} />

                        {/* Material Issue */}
                        <Route path="/material-issue" element={<MaterialIssuePage />} />
                        <Route path="/material-issue/edit/:id" element={<EditMaterialIssue />} />

                        {/* Production Entry */}
                        <Route path="/production-entry" element={<ProductionEntryPage />} />
                        <Route path="/production-entry/edit/:id" element={<EditProductionEntry />} />

                        {/* Maintenance */}
                        <Route path="/maintenance" element={<MaintenancePage />} />
                        <Route path="/maintenance/edit/:id" element={<EditMaintenance />} />

                        <Route path="/preventive-maintenance" element={<PreventiveMaintenancePage />} />
                        <Route path="/preventive-maintenance/edit/:id" element={<EditPreventiveMaintenance />} />

                          {/* Breakdown */}
                        <Route path="/breakdown" element={<BreakdownPage />} />
                        <Route path="/breakdown/edit/:id" element={<EditBreakdown />} />

                        {/* Spare Parts */}
                        <Route path="/spare-part" element={<SparePartsPage />} />
                        <Route path="/spare-part/edit/:id" element={<EditSparePart />} />

                        <Route path="/rfid-page" element={<RFIDTagPage />} />
                        <Route path="/branch-page" element={<BranchPage />} />
                        <Route path="/iot-device" element={<IOTDevicePage />} />
                        <Route path="/iot-data" element={<IOTDataPage />} />
                        <Route path="/iot-map" element={<IOTMapPage />} />
                        <Route path="/prod-move" element={<ProductMovement />} />
                        <Route path="/control-room" element={<ControlRoomDashboard />} />
                    </Route>

                    <Route path="/user-login" element={<Login />} />
               </Routes>
                 {showChatbot && <FloatingChatbot />}
             </AuthProvider>

             <Footer />

    </div>
  );
}
export default Main;
